import React from "react";
import "./calendarTemplate.scss";
import PersonalFooter from "componets/organisms/personalFooter/personalFooter";
import TabsSet from "componets/molecules/comunityTabs/tabsSet";
import Table from "componets/organisms/table/table";
import PageTitle from "componets/molecules/PageTitle/pageTitle";
import imgSrc from "titleImages/calendar.JPG";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";

const CalendarTemplate = ({ data }) => {
  const [page, setPage] = React.useState(1);
  const [election, setElection] = React.useState("todos");
  React.useEffect(() => {
    setPage(1);
  }, [election]);
  const breadcrumsData = [
    { text: "Inicio", link: "/" },
    { text: "Calendario", link: "/Calendario" },
  ];
  const tabsData = {
    groupName: "CalendarSelection",
    tabs: [
      { value: "todos", text: "Todos (das)" },
      { value: "estudiantes", text: "Estudiantes" },
      { value: "facultad", text: "Facultad" },
      { value: "docentes", text: "Docentes" },
    ],
  };

  return (
    <div className="calendar-template__main-container">
      <PageTitle
        breadData={breadcrumsData}
        type="left"
        imgSrc={imgSrc}
        data={{
          title: "CALENDARIO ACADÉMICO",
          subtitle: "2022 - 1S",
          description:
            "La Ingeniería Mecatrónica puede contextualizarse como una disciplina que integra conocimientos para el desarrollo de productos y máquinas que poseen un alto grado de autonomía y funcionalidad encontrada a través de la electrónica, los sistemas inteligentes, la mecánica de precisión, y el control. La Facultad de Ingeniería de la Universidad Nacional de Colombia, Sede de la Paz, ofrece el programa de formación profesional en Ingeniería Mecatrónica con el propósito de fundamentar la innovación y el desarrollo de procesos automatizados en Colombia, modernizando así los sectores productivos del país.",
        }}
      />
      <TabsSet
        textSize={4}
        tabsData={tabsData}
        setSelected={setElection}
      ></TabsSet>
      <Table
        page={page}
        setPage={setPage}
        category={election}
        activities={data.actividades}
      />
      <br />
      <div className="caledar-template__final-description">
        <ReactMarkdown>{data.descripcionFinal}</ReactMarkdown>
      </div>
      <br />
      <br />
      <br />
      <PersonalFooter textSize={1} />
    </div>
  );
};

export default CalendarTemplate;
